/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Sync200ResponseOneOf1ShiftsLastDay } from './Sync200ResponseOneOf1ShiftsLastDay';
import {
    Sync200ResponseOneOf1ShiftsLastDayFromJSON,
    Sync200ResponseOneOf1ShiftsLastDayFromJSONTyped,
    Sync200ResponseOneOf1ShiftsLastDayToJSON,
    Sync200ResponseOneOf1ShiftsLastDayToJSONTyped,
} from './Sync200ResponseOneOf1ShiftsLastDay';

/**
 * 
 * @export
 * @interface Sync200ResponseOneOf1Shifts
 */
export interface Sync200ResponseOneOf1Shifts {
    /**
     * 
     * @type {boolean}
     * @memberof Sync200ResponseOneOf1Shifts
     */
    enabled: boolean;
    /**
     * 
     * @type {Sync200ResponseOneOf1ShiftsLastDay}
     * @memberof Sync200ResponseOneOf1Shifts
     */
    lastDay: Sync200ResponseOneOf1ShiftsLastDay;
}

/**
 * Check if a given object implements the Sync200ResponseOneOf1Shifts interface.
 */
export function instanceOfSync200ResponseOneOf1Shifts(value: object): value is Sync200ResponseOneOf1Shifts {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('lastDay' in value) || value['lastDay'] === undefined) return false;
    return true;
}

export function Sync200ResponseOneOf1ShiftsFromJSON(json: any): Sync200ResponseOneOf1Shifts {
    return Sync200ResponseOneOf1ShiftsFromJSONTyped(json, false);
}

export function Sync200ResponseOneOf1ShiftsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sync200ResponseOneOf1Shifts {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'lastDay': Sync200ResponseOneOf1ShiftsLastDayFromJSON(json['lastDay']),
    };
}

export function Sync200ResponseOneOf1ShiftsToJSON(json: any): Sync200ResponseOneOf1Shifts {
    return Sync200ResponseOneOf1ShiftsToJSONTyped(json, false);
}

export function Sync200ResponseOneOf1ShiftsToJSONTyped(value?: Sync200ResponseOneOf1Shifts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'lastDay': Sync200ResponseOneOf1ShiftsLastDayToJSON(value['lastDay']),
    };
}

